import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const { applyAuth } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const m = window.location.hash.match(/session_id=([^&]+)/);
    if (!m) { navigate("/connexion", { replace: true }); return; }
    const sessionId = decodeURIComponent(m[1]);
    api
      .post("/auth/google/session", { session_id: sessionId })
      .then((r) => {
        applyAuth(r.data.token, r.data.user);
        window.history.replaceState(null, "", "/compte");
        navigate("/compte", { replace: true });
      })
      .catch(() => navigate("/connexion?error=google", { replace: true }));
  }, [applyAuth, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#050505]">
      <Loader2 className="h-8 w-8 animate-spin text-[#C5A059]" />
    </div>
  );
}
